// Preserve the existing project.json format, including raw storage values.
export function serializeProjectSnapshot(storage) {
  var a = {};
  for (var i = 0; i < storage.length; i++) {
    var k = storage.key(i);
    var v = storage.getItem(k);
    a[k] = v;
  }
  return JSON.stringify(a);
}
